import { render, staticRenderFns } from "./WSFinder.Result.vue?vue&type=template&id=68e45994&"
import script from "./WSFinder.Result.vue?vue&type=script&lang=js&"
export * from "./WSFinder.Result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports